import { reducerCreator } from 'redux-rest-helper-for-loopback';
import { orderFormInitValue } from '../../forms/OrderForm';
import OrdersAction from './OrdersAction';

export default reducerCreator(OrdersAction.ENTRY, orderFormInitValue).getReducer();
